import { LOCALE_US_EN, LOCALE_GB_EN } from 'models/location/constants'
import privacyUS from 'privacyPolicies/us/privacy'
import termsUS from 'privacyPolicies/us/terms'
import privacyGB from 'privacyPolicies/gb/privacy'
import termsGB from 'privacyPolicies/gb/terms'

export const getPolicies = (region) => {
    switch (region) {
        case LOCALE_GB_EN:
            return {
                privacy: privacyGB,
                terms: termsGB,
            }
        case LOCALE_US_EN:
            return {
                privacy: privacyUS,
                terms: termsUS,
            }
        default:
            return {}
    }
}

export default getPolicies
